<template>
  <div class="flex flex-col gap-8">

    <FormGroup :label="$t('forms.company.company_properties_form.name')" :error-text="form.errors?.name">
      <InputText
          data-cy="company-name-input"
          v-model="form.name"
          placeholder="e.g. Acme Ltd"
          @change="form.validate('name')"
          :disabled="disabled"/>
    </FormGroup>

    <div class="max-w-sm">
      <InputSwitchFormGroup
          data-cy="select-vehicle-manufacture-input"
          :label="$t('forms.company.company_properties_form.vehicle_manufacturer')"
          :help-text="$t('forms.company.company_properties_form.vehicle_manufacturer_help_text')"
          :error-text="form.errors?.vehicle_manufacturer"
          :disabled="disabled"

          @change="form.validate('vehicle_manufacturer')"
          v-model="form.vehicle_manufacturer"
          :true-value="1"
          :false-value="0"
      />
    </div>

    <FormGroup
        v-show="form.vehicle_manufacturer"
        :label="$t('forms.company.company_properties_form.world_manufacturer_identifier')"
        :error-text="form.errors?.world_manufacturer_identifier"
        :help-text="$t('forms.company.company_properties_form.world_manufacturer_identifier_help_text')"
        help-text-position-top
        class="max-w-md"
    >
      <InputText
          data-cy="world-manufacturer-identifier-value"
          class="max-w-min"
          v-model="form.world_manufacturer_identifier"
          placeholder="e.g. ABC"
          @change="form.validate('world_manufacturer_identifier')"
          minlength="3"
          :disabled="disabled"/>
    </FormGroup>

    <div class="max-w-sm">
      <InputSwitchFormGroup
          :label="$t('forms.company.company_properties_form.two_factor_auth_enabled')"
          :help-text="$t('forms.company.company_properties_form.two_factor_auth_enabled_help_text')"
          :error-text="form.errors?.two_factor_auth_enabled"
          :disabled="disabled"

          @change="onTwoFactorEnabledChange"
          v-model="form.two_factor_auth_enabled"
          :true-value="1"
          :false-value="0"
      />
    </div>

    <div class="max-w-sm">
      <InputSwitchFormGroup
          :label="$t('forms.company.company_properties_form.two_factor_auth_required')"
          :help-text="$t('forms.company.company_properties_form.two_factor_auth_required_help_text')"
          :error-text="form.errors?.two_factor_auth_required"
          :disabled="disabled || !form.two_factor_auth_enabled"

          @change="form.validate('two_factor_auth_required')"
          v-model="form.two_factor_auth_required"
          :true-value="1"
          :false-value="0"
      />
    </div>

  </div>

  <template v-if="hasOnSaveListener || hasOnDeleteListener">
    <div class="flex justify-end space-x-3 mt-8">
      <Button data-cy="company-delete-btn" class="px-8"
              :label="$t('forms.common.delete')"
              severity="danger"
              v-if="hasOnDeleteListener && !disabled && form.id"
              text
              @click="$emit('on-delete', form)"
              :disabled="form.processing"/>

      <Button data-cy="company-save-btn" class="px-8"
              :label="$t('forms.common.save')"
              v-if="hasOnSaveListener && !disabled"
              @click="$emit('on-save', form)"
              :disabled="form.processing"/>
    </div>
  </template>
</template>

<script>
import FormGroup from "@/Components/FormGroup.vue";
import InputSwitchFormGroup from "@/Components/InputSwitchFormGroup.vue";

export default {
  name: "CompanyPropertiesForm",
  components: {InputSwitchFormGroup, FormGroup},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasOnSaveListener() {
      return !!(this.$attrs?.onOnSave);
    },
    hasOnDeleteListener() {
      return !!(this.$attrs?.onOnDelete);
    },
  },
  methods: {
    onTwoFactorEnabledChange() {
      this.form.validate('two_factor_auth_enabled');
      // If 2FA is disabled, also disable the "required" option
      if (!this.form.two_factor_auth_enabled) {
        this.form.two_factor_auth_required = 0;
      }
    },
  },
}
</script>

<style scoped>

</style>
